import { ModelBase } from '../shared/model.base';

export class Role extends ModelBase {
  id: number;
  name: string;
  active: boolean;
  isShared: boolean;

  // for post
  userId: number;
  roleId: number;

  role_actions: any[];
  role_companies: any[];

  constructor() {
    super();
    this.active = true;
  }
}
